import { render, staticRenderFns } from "./DialogGlosary.vue?vue&type=template&id=1b1a9556&scoped=true&"
import script from "./DialogGlosary.vue?vue&type=script&lang=js&"
export * from "./DialogGlosary.vue?vue&type=script&lang=js&"
import style0 from "./DialogGlosary.vue?vue&type=style&index=0&id=1b1a9556&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1a9556",
  null
  
)

export default component.exports